import { LineOperatorsReworkModel } from "./line-operators-rework.model";

export class LinesReworkModel {
    lineWiseReworkInfo: LineOperatorsReworkModel[];

    constructor(lineWiseReworkInfo: LineOperatorsReworkModel[]) {
        this.lineWiseReworkInfo = lineWiseReworkInfo;
    }
}

